import {Component, EventEmitter, Output, Input, ChangeDetectorRef, Injector } from '@angular/core';
import moment from 'moment';
import {ApCustomDateRange, Guid, IColumnPk, SystemGuid} from 'webcommon/shared';
import { ApFindControlBaseComponent, ApFindControlModalService, ApFindControlService } from '../ap-findcontrol/index';
import { ApTimeSpanSelectorModalService } from './ap-timespan-selector-modal.service';
import { TimespanDataDto } from './TimespanDataDto';
import { ValidationErrors } from '@angular/forms';
import { FindControlIdService } from 'webcommon/legacy-common';

@Component({
  selector: 'ap-timespan-find-control',
  styleUrls: ['./ap-timespan-find-control.component.less'],
  templateUrl: '../ap-findcontrol/ap-findcontrol.component.html',
})
export class ApTimespanFindControlComponent extends ApFindControlBaseComponent<TimespanDataDto> {
  @Input() customDateRange: ApCustomDateRange = {};
  @Output() customDateRangeChange = new EventEmitter<ApCustomDateRange>();

  isDateRangeModalActive = false;
  modalResult: ApCustomDateRange = {};
  previousTimespanChip: IColumnPk | null;
  previousCustomDateRange: ApCustomDateRange;

  constructor(
    apFindControlModalService: ApFindControlModalService,
    apFindControlService: ApFindControlService,
    findControlIdService: FindControlIdService,
    changeDetector: ChangeDetectorRef,
    public override systemGuid: SystemGuid,
    private apTimeSpanSelectorModalService: ApTimeSpanSelectorModalService,
    elementInjector: Injector,
  ) {
    super(apFindControlModalService, apFindControlService, findControlIdService, changeDetector, elementInjector, systemGuid);
  }

  protected createFormControlValueOrDefault(): TimespanDataDto {
    return {
      selectedPk: !!this.selectedPk ? Guid._coerceToGuidStr(this.selectedPk) : undefined,
      customDateRange: this.customDateRange,
    };
  }

  protected matchesCurrentFormControlValue(data: TimespanDataDto): boolean {
    return JSON.stringify(this.findControlFormControl?.value) === JSON.stringify(data);
  }

  validate = (): ValidationErrors | null => {
    if (!this.chips.length) {
      if (this.isShowRequiredOnly()) { return null; }
    }
    const valid = this.getIsValid();
    return valid ? null : {
      required: true,
    };
  };

  protected getIsValid(): boolean {
    const isValid = !this.required || !!(this.chips.length);
    return isValid;
  }

  private savePreviousChip() {
    this.previousTimespanChip = (this.chips && this.chips.length) ? this.chips[0] : null;
    this.previousCustomDateRange = this.customDateRange;
  }

  private restorePreviousChip() {
    this.isDateRangeModalActive = false;
    if (this.previousTimespanChip) {
      if (this.previousTimespanChip.Pk === this.systemGuid.ListTimespanCustomDates) {
        this.customDateRange = this.previousCustomDateRange;
        this.customDateRangeChange.emit(this.customDateRange);
        return;
      }
      this.chips.push(this.previousTimespanChip);
    }
    if (this.chips && this.chips.length) {
      this.removeChip(this.chips[0]);
    }
  }

  protected override chipsChanged(chips: IColumnPk[]) {
    super.chipsChanged(chips);
    if (chips && chips.length === 1 && chips[0].Pk === this.systemGuid.ListTimespanCustomDates) {
      if (!this.loadingItems) {
        let modalResult: ApCustomDateRange = {};
        this.isDateRangeModalActive = true;
        this.apTimeSpanSelectorModalService.openModal(this.Id).subscribe(
        // success/next
        (result) => {
          if (result && result.StartDate && result.EndDate) {
            modalResult = result;
            this.customDateRange.StartDate = modalResult.StartDate;
            this.customDateRange.EndDate = modalResult.EndDate;
          } else {
            this.restorePreviousChip();
          }
        },
        // failure
        () => {
          this.restorePreviousChip();
        },
        // complete/finally
        () => {
          this.savePreviousChip();
          this.isDateRangeModalActive = false;
          this.customDateRangeChange.emit(modalResult);
        });
      } else {
        this.savePreviousChip();
      }
    } else {
      this.savePreviousChip();
      this.customDateRange = {};
      this.customDateRangeChange.emit(this.customDateRange);
    }
    this.updateFormControl();
  }

  override getChipDisplayName(data: IColumnPk): string {
    if (this.chips && this.chips.length === 1 && this.chips[0].Pk === data.Pk && data.Pk === this.systemGuid.ListTimespanCustomDates) {
      if (this.isDateRangeModalActive) {
        return 'Choose custom dates';
      }
      if (!this.customDateRange)
      {
        return 'No custom dates selected';
      }
      if (this.customDateRange.StartDate) {
        const dateString = moment(this.customDateRange.StartDate).format('M/D/YYYY');
        if (this.customDateRange.EndDate) {
          return dateString + ' - ' + moment(this.customDateRange.EndDate).format('M/D/YYYY');
        } else {
          return dateString;
        }
      } else if (this.customDateRange.EndDate) {
        return moment(this.customDateRange.EndDate).format('M/D/YYYY');
      } else {
        return 'Not valid date range';
      }
    } else {
      return super.getChipDisplayName(data);
    }
  }
}
